module.exports = __webpack_public_path__ + "img/ava-1.a1f25fba.webp";